<template>
  <el-collapse-item
    title="Actions"
    name="actions"
  >
    <section class="drawer-panel-section">
      <div class="actions flex flex-column">
        <ActivateAccount
          :user="user"
          :is-recruiter="false"
        />

        <PromoteAccount :user="user"/>

        <DeleteAccount :user="user"/>
      </div>
    </section>
  </el-collapse-item>
</template>

<script>
export default {
  name: 'CandidateActions',
  components: {
    ActivateAccount: () => import('@/components/UserDrawer/Sections/Actions/ActivateAccount'),
    PromoteAccount: () => import('@/components/UserDrawer/Sections/Actions/PromoteAccount'),
    DeleteAccount: () => import('@/components/UserDrawer/Sections/Actions/DeleteAccount')
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
}
</script>

<style lang="scss">
  @import "~vars";

  .actions .el-button {
    margin: 0 0 $-padding-unit 0;
  }
</style>
